// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestedUserCard-cls1_f1v","cls2":"SuggestedUserCard-cls2_WmN SuggestedUserCard-cls1_f1v"};